import { Checkbox as AlphaCheckbox } from '@oneaudi/unified-web-alpha-components';

export default AlphaCheckbox;
